import React from "react";
import "./TopWidget.less";
import { apiRequest, apiPost } from "../../../../utils/api_service";
import { API_URL } from "../../../../constants/api";
import BlockIcon from "@material-ui/icons/Block";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import TransferWithinAStationIcon from "@material-ui/icons/TransferWithinAStation";
import {
  AppBar,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  TextField,
  Toolbar,
  Tooltip,
  Typography
} from "@material-ui/core";
import moment from "moment";
import { ShowToast, toastType } from "../../../../utils/toast-service";
import EditIcon from "@material-ui/icons/Edit";
import CancelIcon from "@material-ui/icons/Cancel";
import { InfoOutlined } from "@material-ui/icons";
import camelcaseKeys from "camelcase-keys";
import DenseTable from "../../../Dashboard/RenderTable";
import { getSynchStatus, PaperComponent } from "../../../../utils/helper";
import { IoMdCloseCircleOutline } from "react-icons/io";

const CData = [
  { key: "WorkOrderId", name: "Work Order Id" },
  { key: "Datacenter", name: "Data Center Name" },
  { key: "JobType", name: "Job Type" },
  { key: "ReceivedDate", name: "Received Date", format: "DateTime" },
  { key: "DueDate", name: "Due Date", format: "DateTime" },
  { key: "ClosedDate", name: "Closed Date", format: "DateTime" },
  { key: "Requestor", name: "Requestor" },
  { key: "Type", name: "Type" },
  { key: "Status", name: "Status" },
  { key: "ServiceLocation", name: "Service Location" },
  { key: "Technician", name: "Technician" },
  { key: "WorkHours", name: "Work Hours" },
  { key: "ServiceDescription", name: "Description", width: 450 },
  { key: "Source", name: "Source" }
];

const wData = [
  { key: "Datacenter", name: "Data Center Name" },
  { key: "IncidentNo", name: "Incident No" },
  { key: "IncidentCategory", name: "Incident Category" },
  { key: "ReceivedDate", name: "Received Date", format: "DateTime" },
  { key: "IncidentStatus", name: "Incident Status" },
  { key: "ReportedBy", name: "Reported By" },
  { key: "Location", name: "Location" },
  { key: "Description", name: "Description", width: 450 }
];
class TopWidget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      widgetData: [],
      ValuesToUpdate: [],
      editFields: false,
      conditions: [],
      rawData: [],
      SortedRawData: [],
      IsConditionOpen: false,
      FiltersView: false,
      SelectedAttribute: undefined,
      syncStatus: undefined
    };
  }

  componentDidMount() {
    this.GetTopWidgetData(
      this.props.propertyId,
      this.props.startDate,
      this.props.endDate,
      this.props.customUrl
    );
  }
  componentWillReceiveProps(newProps) {
    if (
      newProps.propertyId != this.props.propertyId ||
      newProps.startDate != this.props.startDate ||
      newProps.endDate != this.props.endDate
    ) {
      this.GetTopWidgetData(
        newProps.propertyId,
        newProps.startDate,
        newProps.endDate,
        newProps.customUrl
      );
    }
  }

  /** top widget data */
  GetTopWidgetData = (propertyId, startDate, endDate, customUrl) => {
    const params = {
      propertyId: propertyId,
      startDate: startDate,
      endDate: endDate
    };

    if (customUrl != null) {
      apiRequest({
        url: customUrl,
        params
      }).then(StaffingSummary => {
        //console.log(StaffingSummary.data);
        this.setState({
          widgetData: StaffingSummary.data,
          conditions: camelcaseKeys(StaffingSummary.condition),
          rawData: StaffingSummary.rawData,
          syncStatus: ((StaffingSummary.syncStatus || [])[0] || {}).SyncStatus
        });
      });
    }
  };

  /** call on handle change */
  handleChange = () => {
    (this.state.ValuesToUpdate || []).map(item => {
      const bodyToPost = {
        propertyId: parseInt(this.props.propertyId),
        sectionDetailId: item.attributeId,
        attributeValue: item.value + "|" + "0",
        startDate: moment(this.props.startDate).format("YYYY-MM-DD"),
        endDate: moment(this.props.endDate).format("YYYY-MM-DD")
      };
      // console.log(bodyToPost);
      apiPost({
        url: API_URL.datacenter.UpdateDataCenterAttribute,
        params: [],
        postBody: bodyToPost
      }).then(({ data: response }) => {
        if (response.success == true) {
          ShowToast(
            "Record updated successfully.",
            toastType.SUCCESS,
            5000,
            200
          );
          this.props.toUpdateGraph(Math.random());
          this.setState({ ValuesToUpdate: [], editFields: false });
          this.GetTopWidgetData(
            this.props.propertyId,
            this.props.startDate,
            this.props.endDate,
            this.props.customUrl
          );
        }
      });
    });
  };

  /** call on handle value change */
  handleChangeValue(value, attributeId) {
    if (value < 0) {
      ShowToast("Please enter positive value", toastType.ERROR, 5000);
      return false;
    }

    const { ValuesToUpdate } = this.state;
    const TempArray = ValuesToUpdate;
    TempArray.push({ value, attributeId });
    this.setState({ ValuesToUpdate: TempArray });
  }

  /** details */
  getDetailByAttributeAndType = attributeName => {
    let result;
    if (attributeName == "Total") {
      result = this.state.rawData;
    } else {
      result = this.state.rawData.filter(
        value => value.AttributeName == attributeName
      );
    }

    this.setState({
      SortedRawData: result,
      IsConditionOpen: true,
      SelectedAttribute: attributeName
    });
  };

  render() {
    const {
      widgetData,
      conditions,
      SortedRawData,
      IsConditionOpen,
      FiltersView,
      SelectedAttribute,
      syncStatus
    } = this.state;
    // console.log(widgetData);
    const { Permission } = this.props;
    const IsEditable = Permission.accessTypeId > 1 ? true : false;
    const ShowData = Permission.showData;

    return (
      <>
        <div className={"w-100 security-top-widget"}>
          {this.state.ValuesToUpdate.length > 0 &&
          this.state.editFields == true ? (
            <div className={"w-100 save-bar-message mt-1"} style={{}}>
              {"Please"}{" "}
              <span className={"Save-click"} onClick={this.handleChange}>
                {"Click Here\r"}
              </span>{" "}
              {"to save the changes.\r"}
            </div>
          ) : null}
          <div className={"security-top-widget-title-div"}>
            <div className={"w-80 security-widget-Title "}>
              {this.props.title}{" "}
              {ShowData && (
                <Tooltip title={"View Filters"}>
                  <IconButton
                    onClick={() =>
                      this.setState({
                        IsConditionOpen: true,
                        FiltersView: true
                      })}
                    size={"small"}
                  >
                    <InfoOutlined fontSize={"small"} size={"small"} />
                  </IconButton>
                </Tooltip>
              )}
              {IsEditable && (
                <>
                  {" "}
                  {this.props.title == "Guard-Force Patrols" ? (
                    this.state.editFields == false ? (
                      <Tooltip title={"Edit Records"} placement={"bottom"}>
                        <IconButton size={"small"}>
                          <EditIcon
                            fontSize={"small"}
                            style={{ fontSize: "15px", cursor: "pointer" }}
                            onClick={() => {
                              this.setState({
                                editFields: true,
                                ValuesToUpdate: []
                              });
                            }}
                          />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <Tooltip
                        title={"Cancel Editing Records"}
                        placement={"bottom"}
                      >
                        <IconButton size={"small"}>
                          <CancelIcon
                            fontSize={"small"}
                            style={{ fontSize: "15px", cursor: "pointer" }}
                            onClick={() => {
                              this.setState({ editFields: false });
                            }}
                          />
                        </IconButton>
                      </Tooltip>
                    )
                  ) : null}
                </>
              )}
            </div>
            <div className={"w-20 security-widget-icon"}>
              {this.props.title == "Access Denials" ? (
                <BlockIcon fontSize={"large"} />
              ) : null}
              {this.props.title == "Site Personnel Activity" ? (
                <TransferWithinAStationIcon fontSize={"large"} />
              ) : null}
              {this.props.title == "Guard-Force Patrols" ? (
                <>
                  <VerifiedUserIcon fontSize={"large"} />
                </>
              ) : null}
            </div>
          </div>
          {(widgetData || []).map((item, index) =>
            item.isEditable == 1 && IsEditable ? (
              <div
                className={"security-top-widget-title-data"}
                key={"widget-title-data" + index}
              >
                <div className={"w-80 security-list-title"}>
                  {item["attributeName"]}
                </div>
                <div className={"w-20 security-widget-count"}>
                  {" "}
                  {this.state.editFields == true ? (
                    <TextField
                      className={"editableTextInput"}
                      type={"number"}
                      id={"standard-basic"}
                      size={"small"}
                      InputProps={{ inputProps: { min: 0 } }}
                      defaultValue={item.attributeValue}
                      onBlur={event => {
                        this.handleChangeValue(
                          event.target.value,
                          item.sectionDetailId
                        );
                      }}
                    />
                  ) : item.attributeValue != null ? (
                    item.attributeValue
                  ) : (
                    "-"
                  )}
                </div>
              </div>
            ) : (
              <div
                className={"security-top-widget-title-data"}
                key={"widget-title-data" + index}
              >
                <div className={"w-80 security-list-title"}>
                  {item["attributeName"] != null ? item["attributeName"] : "-"}
                </div>
                <div
                  className={
                    item["dataFormat"] == "PercentNumber" &&
                    parseFloat(item["attributeValue"]) <= 30 &&
                    parseFloat(item["attributeValue"]) >= 0
                      ? "w-20 security-widget-count error-gsf-class " +
                        (ShowData && !(item["isClickable"] == 0)
                          ? "pointer underline"
                          : "")
                      : item["dataFormat"] == "PercentNumber" &&
                        parseFloat(item["attributeValue"]) <= 60 &&
                        parseFloat(item["attributeValue"]) > 30
                      ? "w-20 security-widget-count warning-gsf-class " +
                        (ShowData && !(item["isClickable"] == 0)
                          ? "pointer underline"
                          : "")
                      : item["dataFormat"] == "PercentNumber" &&
                        parseFloat(item["attributeValue"]) > 60
                      ? "w-20 security-widget-count green-gsf-class " +
                        (ShowData && !(item["isClickable"] == 0)
                          ? "pointer underline"
                          : "")
                      : "w-20 security-widget-count " +
                        (ShowData && !(item["isClickable"] == 0)
                          ? "pointer underline"
                          : "")
                  }
                  onClick={() =>
                    ShowData &&
                    item["isClickable"] == 1 &&
                    this.getDetailByAttributeAndType(
                      item["attributeName"],
                      null
                    )}
                >
                  {" "}
                  {item["attributeValue"] == null
                    ? "-"
                    : item["attributeValue"]}
                  {item["dataFormat"] == "PercentNumber" &&
                  item["attributeValue"] !== null
                    ? "%"
                    : ""}
                </div>
              </div>
            )
          )}
        </div>
        {IsConditionOpen && (
          <Dialog
            open={IsConditionOpen}
            maxWidth={"md"}
            onClose={() =>
              this.setState({ IsConditionOpen: false, FiltersView: false })}
            aria-labelledby={"responsive-dialog-title"}
            PaperComponent={PaperComponent}
            fullScreen={!FiltersView}
          >
            <AppBar
              style={{ position: "relative", backgroundColor: "#064473" }}
            >
              <Toolbar>
                <Typography variant={"h6"} style={{ flex: "1" }}>
                  {FiltersView ? (
                    <DialogTitle
                      style={{ cursor: "move" }}
                      id={"responsive-dialog-title"}
                      className={"common-color white-label"}
                    >
                      {this.props.title}
                      <span className={"condition-label white-label"}>
                        {"(Applied filters)\r"}
                      </span>
                    </DialogTitle>
                  ) : (
                    <DialogTitle
                      style={{ cursor: "move" }}
                      id={"responsive-dialog-title"}
                    >
                      {SelectedAttribute}
                    </DialogTitle>
                  )}
                </Typography>
                <Tooltip title={"Close"}>
                  <IconButton
                    edge={"end"}
                    color={"inherit"}
                    onClick={() => {
                      this.setState({
                        IsConditionOpen: false,
                        FiltersView: false
                      });
                    }}
                    aria-label={"close"}
                    className={"white-button"}
                  >
                    <IoMdCloseCircleOutline />
                  </IconButton>
                </Tooltip>
              </Toolbar>
            </AppBar>

            <DialogContent>
              <DialogContentText>
                {FiltersView ? (
                  conditions &&
                  conditions.map(item => (
                    <div className={"col-xs-12"}>
                      <div className={"col-xs-12 start-xs condition-heading"}>
                        <b>{item.attributeName}</b>{" "}
                      </div>
                      <div>
                        {item.filterCondition.split("|").map(condition => (
                          <div className={"col-xs-11 condition-label"}>
                            {condition}{" "}
                          </div>
                        ))}{" "}
                      </div>
                    </div>
                  ))
                ) : (
                  <div>
                    <div>
                      <DenseTable
                        columns={
                          this.props.title == "Access Denials" ? wData : CData
                        }
                        data={SortedRawData}
                        config={{
                          minRows: 10
                        }}
                      />
                    </div>
                  </div>
                )}
                {syncStatus && (
                  <span className={"data-sync-text"}>
                    {getSynchStatus(syncStatus)}
                  </span>
                )}
              </DialogContentText>
            </DialogContent>
          </Dialog>
        )}
      </>
    );
  }
}

export default TopWidget;
